import { Component, OnInit } from '@angular/core';
import { DataProviderService } from '../../../service/data-provider.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
@Component({
  selector: 'app-expressions',
  templateUrl: './expression.component.html',
  styleUrls: ['./expression.component.css'],
  animations: [
    trigger('expressionState', [
      state('inactive', style({
        transform: 'scale(2)'
      })),
      state('active', style({
        transform: 'scale(1)'
      })),
      transition('inactive => active', animate('500ms ease-in')),
      transition('active => inactive', animate('500ms ease-out'))
    ])
  ]
})
export class ExpressionComponent implements OnInit {

  Expressions: any;
  constructor(private datapro: DataProviderService) {
    this.Expressions = []
    this.datapro.expressions.Expressions.forEach(element => {
      this.Expressions.push({ Title: element.Title, state: "inactive" })
    });
    this.Expressions[0].state = 'active';
    this.changeExpression(1);
  }

  changeExpression(index) {
    if (!(this.Expressions.length === index))
      setTimeout(() => {
        this.Expressions[index].state = 'active';
        this.Expressions[index - 1].state = 'inactive';
        this.changeExpression(index + 1);
      }, 3000);

  }

  ngOnInit() {
  }

}
